import {
  GALLERY_PAGE_SIZE,
  GALLERY_PAGE_SIZE_WITH_PAGINATION,
} from '../../constants'

export const isPaginationExperimentVariant = (variant: string | undefined) =>
  variant?.toLowerCase() === 'variant'

export const isPageNavigationEnabled = (galleryPageSize: number) =>
  galleryPageSize === GALLERY_PAGE_SIZE_WITH_PAGINATION

export const getGalleryPageSize = (usePageNavigation: boolean) =>
  usePageNavigation ? GALLERY_PAGE_SIZE_WITH_PAGINATION : GALLERY_PAGE_SIZE
